import theme from '../../theme';

const EditIcon = ({ color = theme.palette.text.secondary }) => {
  return (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.9138 9.17122L23.3288 3.58497C23.143 3.39921 22.9225 3.25185 22.6799 3.15131C22.4372 3.05077 22.1771 2.99902 21.9144 2.99902C21.6517 2.99902 21.3916 3.05077 21.1489 3.15131C20.9062 3.25185 20.6857 3.39921 20.5 3.58497L5.08626 19C4.89973 19.185 4.75185 19.4053 4.65121 19.648C4.55057 19.8907 4.49917 20.151 4.50001 20.4137V26C4.50001 26.5304 4.71072 27.0391 5.0858 27.4142C5.46087 27.7893 5.96958 28 6.50001 28H12.0863C12.349 28.0008 12.6093 27.9494 12.852 27.8488C13.0947 27.7481 13.315 27.6002 13.5 27.4137L28.9138 12C29.0995 11.8142 29.2469 11.5937 29.3474 11.3511C29.448 11.1084 29.4997 10.8483 29.4997 10.5856C29.4997 10.3229 29.448 10.0628 29.3474 9.82012C29.2469 9.57744 29.0995 9.35695 28.9138 9.17122ZM6.91376 20L17.5 9.41372L19.5863 11.5L9.00001 22.085L6.91376 20ZM6.50001 22.4137L10.0863 26H6.50001V22.4137ZM12.5 25.5862L10.4138 23.5L21 12.9137L23.0863 15L12.5 25.5862ZM24.5 13.5862L18.9138 7.99997L21.9138 4.99997L27.5 10.585L24.5 13.5862Z"
        fill={color}
      />
    </svg>
  );
};

export default EditIcon;
